import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ReportLocation } from '@portals/api';
import { BaseComponent } from '@portals/core';
import { TableHeader } from '@portals/ui';

@Component({
	selector: 'portals-mapping',
	templateUrl: './mapping.component.html',
	styleUrls: ['./mapping.component.scss'],
})
export class MappingComponent<T = unknown> extends BaseComponent {
	columns: TableHeader[] = [
		{
			text: 'Street',
			key: 'street',
		},
		{
			text: 'Longitude',
			key: 'location.longitude',
		},
		{
			text: 'Latitude',
			key: 'location.latitude',
		},
		{
			text: 'Created At',
			key: 'createdAt',
			pipe: 'date',
			pipeArgs: ['MMM d, y'],
		},
	];

	@Input() locations!: Array<T>;
	@Input() searchPlaceholder = 'Search';
	@Input() reportLocationEnabled = false;
	@Output() locationSelected = new EventEmitter<T>();
	public term!: any;

	constructor() {
		super();
	}

	onMouseOver(infoWindow: any, event: any) {
		infoWindow.open();
	}

	onMouseOut(infoWindow: any, event: any) {
		infoWindow.close();
	}
}
